/**
 * Search types and labels with no data behind them.
 *
 * The sitewide header imports these on every page, so this module must never
 * import the index: src/lib/search-index.ts statically imports ~105 KB of blog
 * entries, and importing even a helper from it put that file in every page's
 * initial JavaScript. The index loads on demand through loadSearchEngine() in
 * src/hooks/useSearch.ts.
 */
export interface SearchableItem {
  id: string
  title: string
  description: string
  category: 'blog' | 'project' | 'service' | 'page'
  url: string
  tags?: string[]
}

export function getCategoryLabel(category: SearchableItem['category']): string {
  const labels = {
    blog: 'Blog',
    project: 'Project',
    service: 'Service',
    page: 'Page',
  }
  return labels[category]
}
